import { createFileRoute } from '@tanstack/react-router'
import { DocumentsContainer } from 'pages/documents/DocumentsContainer'
import { EmbeddedTrendWorkbenchProvider } from 'pages/processData/EmbeddedTrendWorkbenchProvider'

import { documentsSearchSchema } from './-searchParams'

const RouteComponent = () => {
  return (
    <EmbeddedTrendWorkbenchProvider>
      <DocumentsContainer />
    </EmbeddedTrendWorkbenchProvider>
  )
}

export const Route = createFileRoute('/documents/')({
  component: RouteComponent,
  validateSearch: documentsSearchSchema,
  staticData: {
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
